import { CustomerView } from './customer.types';
import { externalApiClient } from '@/shared/lib/apiClient';
import axios from 'axios';

async function getCustomerByMisoId(misoCustomerId: string): Promise<CustomerView> {
  try {
    const headers = { 'Content-Type': 'application/json' };
    const response = await externalApiClient.get<CustomerView>(
      `/api/v1/customers/by-miso-id/${misoCustomerId}`,
      { headers }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        '고객 조회에 실패했습니다.';
      throw new Error(errorMessage);
    }
    throw new Error('알 수 없는 오류가 발생했습니다.');
  }
}

export const customerApi = {
  getCustomerByMisoId,
};
